// src/components/SpamFolderWarning.js
import React from 'react';
import './SpamFolderWarning.css';

const SpamFolderWarning = () => (
  <div className="spam-warning">
    <div className="spam-warning-icon">📬</div>
    <h3 className="spam-warning-title">CHECK YOUR SPAM / JUNK FOLDER</h3>
    <p className="spam-warning-body">
      Verification emails from WasteGame sometimes land in spam. If you don't see the email in your inbox within 2 minutes:
    </p>
    <ol className="spam-warning-steps">
      <li>Check your spam/junk folder</li>
      <li>Mark the email as <strong>'Not Spam'</strong> (this helps future emails arrive properly)</li>
      <li>Click the verification link inside</li>
    </ol>
    <p className="spam-warning-contact">
      Still nothing?{' '}
      <a href="mailto:info@thewastegame.co.uk" className="spam-warning-link">
        Contact info@thewastegame.co.uk
      </a>{' '}
      and we'll sort it.
    </p>
  </div>
);

export default SpamFolderWarning;
